import { z } from "zod";

export const searchItemMetaSchema = z.object({
  id: z.string(),
  engine: z.string(),
  score: z.number(), // float
});
